<template>
    <!--begin::Modal-->
    <b-modal size="lg" id="TypeModal" v-model="showModal"
             :title="typeId ? 'Update type' : 'Add new type'"
            @hidden="close">
        <b-container>
            <loading :active.sync="isLoading"
                     :z-index="99999"
                     :can-cancel="false"
                     :is-full-page="true"></loading>
            <!--begin::Form-->
            <form class="m-form m-form--label-align-right">
                <div class="m-portlet__body">
                    <div class="m-form__content">
                        <div class="m-alert m-alert--icon alert alert-danger" role="alert" v-if="error"
                             id="m_form_1_msg">
                            <div class="m-alert__icon">
                                <i class="la la-warning"></i>
                            </div>
                            <div class="m-alert__text" v-html="message">
                            </div>
                            <div class="m-alert__close">
                                <button type="button" class="close" @click="error=false" aria-label="Close"></button>
                            </div>
                        </div>
                    </div>
                    <div class="m-form__section m-form__section--first">
                        <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Name
                            </label>
                            <div class="col-lg-9">
                                <input type="text" required="required" v-model="name" class="form-control m-input">
                                <span class="m-form__help"> Please enter name </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <!--end::Form-->
        </b-container>
        <div slot="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showModal=false">Close</button>
            <button type="button" class="btn btn-brand" @click="modifyType">{{ typeId ? 'Update' : 'Create'}}
            </button>
        </div>
    </b-modal>
    <!--end::Modal-->
</template>

<script>
    import TypeApi from '../../api/report_type';

    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';


    export default {
        components: {
            Loading

        },
        name: "type-modal",
        props: ['typeId'],
        data() {
            return {
                fullPage: true,
                isLoading: false,
                fullPage: true,
                isLoading: false,
                success: false,
                error: false,
                message: null,
                showModal: false,
                id: this.typeId,
                name: null,
            }
        },
        watch: {
            typeId(val) {
                if (val) {
                    TypeApi.getTypeDetail(this, val, (context) => {
                        if (context.type) {
                            this.name = context.type.name;
                        }
                    })
                }else{
                    this.resetData();
                }
            },
        },
        methods: {
            modifyType() {
                this.error = false;
                this.isLoading = true;
                if (this.typeId) {
                    TypeApi.updateType(this, this.typeId, {
                        name: this.name,
                    }, (context) => {
                        this.isLoading = false;
                        if (context.success) {
                            this.close();
                            this.$emit('show-update-success-alert');

                        }
                    })
                } else {
                    TypeApi.createType(this, {
                        name: this.name,
                    }, (context) => {
                        this.isLoading = false;
                        if (context.success) {
                            this.close();
                            this.$emit('show-create-success-alert');
                        }
                    })
                }
            },
            resetData() {
                this.id = null;
                this.name = null;
            },
            close() {
                //this.resetData();
                this.$emit('clear-id');
                this.error = false;
                this.showModal = false;
            }
        }
    }
</script>

<style scoped>

</style>